import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BusinessGoalsGoalIndexRoute extends Route {
  @service router;

  beforeModel() {
    this.router.transitionTo('business.goals.goal.description');
  }
}

export default instrumentRoutePerformance(BusinessGoalsGoalIndexRoute);
